import { ColorIdBorder } from '@/components/common/ColorIdBorder'
import { type RecType } from '@/defs/rec'
import { useCardsRec } from '@/hooks/useCardsRec'
import { getColorId } from '@/utils/cardUtil'
import { cn, isNonEmptyString } from '@/utils/commonUtil'
import { getRecName } from '@/utils/recUtil'

import styles from './CardArtFrame.module.scss'

type Props = {
  rec?: RecType
}

export const CardArtFrame = ({ rec }: Props) => {
  const { card, cardPartner, loading } = useCardsRec({ rec })

  if (loading || !card) return null

  const colorId = getColorId(card.colorId, cardPartner?.colorId)
  const images = [card.imageArt, cardPartner?.imageArt].filter(isNonEmptyString)
  const name = getRecName(rec)

  return (
    <div className={cn(styles.container, { count: String(images.length), styles })}>
      <ColorIdBorder colorId={colorId}>
        {images.map((c, i) => (
          <img alt={`Card art for ${name}`} className={styles.image} decoding='async' key={i} loading='lazy' src={c} />
        ))}
      </ColorIdBorder>
    </div>
  )
}
